import { render, staticRenderFns } from "./ProgramDialog.vue?vue&type=template&id=47fffe41&scoped=true&"
import script from "./ProgramDialog.vue?vue&type=script&lang=js&"
export * from "./ProgramDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fffe41",
  null
  
)

export default component.exports